import { IPlanEnrollment } from "./types";
import { planEnrollmentService } from "./service";

export const withdrawCancellationPlanEnrollment = async (
  planEnrollmentId: string
): Promise<IPlanEnrollment> => {
  const { data } = await planEnrollmentService.post(
    `/${planEnrollmentId}/withdraw-cancellation`
  );
  return data;
};
